import SliderInput from './Slider';
import { useLanguage } from '../../context/LanguageContext';

export default function SliderUseful({ value, onChange }) {
  const { t } = useLanguage();

  return (
    <SliderInput
      description={[
        `${t('useless')}`,
        `${t('notUseful')}`,
        `${t('neitherUseful')}`,
        `${t('somewhatUseful')}`,
        `${t('veryUseful')}`,
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
